import api from "../security/api";

const save = (client, instance, file, arrayRequest) => {
    return api
        .post(`scheduledFile/save?client=${client}&instance=${instance}&file=${file}`, arrayRequest);
};

const savePdfs = (client, instance, arrayRequest) => {
    return api
        .post(`scheduledFile/savePdfs?client=${client}&instance=${instance}`, arrayRequest);
};

const scheduledFileService = {
    save,
    savePdfs
};


export default scheduledFileService;
